<template>
    <div class="myskov-area__content">
        <saved-offers v-if="page == 'offers'"></saved-offers>
        <myskov-orders v-if="page == 'orders'"></myskov-orders>
        <myskov-profile v-if="page == 'profile'"></myskov-profile>
        <myskov-newsletter v-if="page == 'newsletter'"></myskov-newsletter>
        <myskov-help v-if="page == 'help'"></myskov-help>
    </div>
</template>

<script>
import SavedOffers from './saved-offers.vue';
import MyskovOrders from './myskov-orders.vue';
import MyskovProfile from './myskov-profile.vue';
import MyskovNewsletter from './myskov-newsletter.vue';
import MyskovHelp from './myskov-help.vue';

export default {
    computed: {
        page() {
            return this.$route.params.page;
        }
    },
    components: {
        SavedOffers,
        MyskovOrders,
        MyskovProfile,
        MyskovProfile,
        MyskovNewsletter,
        MyskovHelp
    }
}
</script>
